import {
  FormField,
  type IFormFieldProps,
  Input,
  type IInputProps,
} from "@/ui-kit";
import { useId } from "react";
import { Controller, useFormContext, useFormState } from "react-hook-form";
import { get } from "../utils";
import { useTranslation } from "react-i18next";

type IProps = Omit<IInputProps, "label"> &
  Partial<IFormFieldProps> & {
    name: string;
    formElementClass?: string;
    clear?: boolean;
  };

export const InputControl = (props: IProps) => {
  const {
    label,
    message,
    required,
    tooltipContent,
    accessory,
    formElementClass,
    name,
    invalid,
    clear,
    description,
    ...restInputProps
  } = props;
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { errors } = useFormState();
  const errorMessage = get(errors, name)?.message as string | undefined;
  const inputId = useId();

  const placeholder =
    props.placeholder !== undefined
      ? props.placeholder
      : label && typeof label === "string"
        ? t("placeholder.enter_what", {
            what: label.toLowerCase(),
          })
        : "";

  const inputElement = (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange: onFieldChange, onBlur, value } }) => {
        const handleClear = () => {
          onFieldChange("");
        };

        return (
          <Input
            {...restInputProps}
            required={required}
            name={name}
            onChange={onFieldChange}
            onBlur={onBlur}
            value={value}
            invalid={invalid || !!errorMessage}
            autoComplete="off"
            id={inputId}
            placeholder={placeholder}
            onClear={
              restInputProps.onClear || (clear ? handleClear : undefined)
            }
          />
        );
      }}
    />
  );

  return (
    <FormField
      label={label}
      message={message ?? errorMessage}
      description={description}
      required={required}
      tooltipContent={tooltipContent}
      className={formElementClass}
      accessory={accessory}
      htmlFor={inputId}
      color={restInputProps.color}
    >
      {inputElement}
    </FormField>
  );
};
